import axios from 'axios'
import jwt from 'jsonwebtoken'
import { showToast } from '@services/toast'

const enviroment = process.env.NODE_ENV
const tokenName = `eemovel_home_equity_token_${enviroment}`
const refreshTokenName = `eemovel_home_equity_refresh_token_${enviroment}`
const credentialName = `eemovel_home_equity_credential_${enviroment}`
const apiKeyName = `eemovel_home_equity_api_key_${enviroment}`

const API_URL = process.env.REACT_APP_API_URL
const SIGN_IN = `${API_URL}/users/public/sign-in`
const REFRESH_TOKEN = `${API_URL}/users/public/refresh`
const API_KEY = `${API_URL}/providers/api-key`
const USER_INFO = `${API_URL}/valuate/user-info`

export const headers = {
  Authorization: `${sessionStorage.getItem(tokenName)}`,
}

export const login = async ({ email, password }, loading, setError) => {
  try {
    loading(true)
    setError('')
    const signInResponse = await axios.post(SIGN_IN, { email, password })
    const resfreshResponse = await axios.post(REFRESH_TOKEN, {
      RefreshToken: signInResponse?.data?.data?.RefreshToken,
    })

    const idToken = resfreshResponse?.data?.data?.IdToken

    if (idToken) {
      await axios.get(USER_INFO, {
        headers: { Authorization: idToken },
      })
      const userInformation = jwt.decode(idToken)
      const apiKey = await axios.get(API_KEY, {
        headers: { Authorization: idToken },
      })

      sessionStorage.setItem(
        refreshTokenName,
        signInResponse?.data?.data?.RefreshToken,
      )
      sessionStorage.setItem(credentialName, JSON.stringify(userInformation))
      sessionStorage.setItem(tokenName, idToken)
      sessionStorage.setItem(apiKeyName, apiKey?.data?.data?.api_key)

      window.location = '/avaliacao'
    }
  } catch (err) {
    if (err?.response?.status === 401) setError('Usuário ou senha incorretos')
    if (err?.response?.status === 403) {
      setError('Você não tem acesso a esse produto.')
      logout(false)
    }
    console.error(err)
  }

  loading(false)
}

export const authed = () => {
  const token = sessionStorage.getItem(tokenName)
  return !!token
}

export const getUserInfo = () =>
  JSON.parse(sessionStorage.getItem(credentialName))

export const getApiKey = () => sessionStorage.getItem(apiKeyName)

export const getToken = () => sessionStorage.getItem(tokenName)

export const refreshToken = async () => {
  try {
    const resfreshResponse = await axios.post(REFRESH_TOKEN, {
      RefreshToken: sessionStorage.getItem(refreshTokenName),
    })

    const idToken = resfreshResponse?.data?.data?.IdToken

    if (idToken) {
      sessionStorage.setItem(tokenName, idToken)
    } else {
      const err = { message: 'Sessão expirou' }
      throw err
    }
  } catch (err) {
    showToast('Sessão expirou, faça login novamente', 'failure')
    setTimeout(logout, 500)
  }
}

export const logout = (redirect = true) => {
  sessionStorage.removeItem(tokenName)
  sessionStorage.removeItem(credentialName)
  sessionStorage.removeItem(apiKeyName)
  sessionStorage.removeItem(refreshTokenName)

  if (redirect) window.location = '/'
}
